"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProductAreaLabel = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _dateFormat = _interopRequireDefault(require("@insided/destination/utils/dateFormat"));

var _common = require("@insided/shared/utils/common");

var _OnDemandTranslations = require("@insided/shared/modules/HubAI/OnDemandTranslations");

var _dateFormatDestination = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/dateFormatDestination"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicHeaderMetaInfo = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicHeaderMetaInfo, _Component);

  var _super = _createSuper(TopicHeaderMetaInfo);

  function TopicHeaderMetaInfo() {
    (0, _classCallCheck2.default)(this, TopicHeaderMetaInfo);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(TopicHeaderMetaInfo, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          publishedAt = _this$props.publishedAt,
          lastEditedAt = _this$props.lastEditedAt,
          productAreas = _this$props.productAreas,
          views = _this$props.views,
          totalReplyCount = _this$props.totalReplyCount;
      var publishTime = new Date(publishedAt !== null && publishedAt !== void 0 ? publishedAt : new Date()).getTime();
      var lastEditedTime = lastEditedAt ? new Date(lastEditedAt).getTime() : undefined;
      var TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;
      var isEditedAtLeast24hAfterPublish = lastEditedTime !== undefined && lastEditedTime - publishTime >= TWENTY_FOUR_HOURS_MS;
      return (0, _preact.h)("div", null, productAreas && Boolean(Object.keys(productAreas).length) && (0, _preact.h)("div", {
        className: "product-area-meta-container",
        "data-qa": "product-area-container"
      }, (0, _preact.h)("span", {
        className: "text--meta"
      }, ' ', (0, _preact.h)(_phrase.default, {
        p: "product.areas.related.products"
      }), ":"), productAreas.map(function (_ref) {
        var id = _ref.id,
            name = _ref.name;
        return (0, _preact.h)(ProductAreaLabel, {
          key: id,
          name: name
        });
      })), (0, _preact.h)("ul", {
        className: (0, _classnames.default)('list', 'list--dot-seperated', 'text--meta', 'm-v-S', 'qa-topic-meta')
      }, !_common.common.isModuleActive('threadedRepliesDestination') && !_common.common.isModuleActive('threadedRepliesControl') && (0, _preact.h)("li", null, (0, _preact.h)("div", null, (0, _preact.h)("div", {
        "data-view": "Tooltip",
        className: "tooltip"
      }, (0, _preact.h)("time", {
        className: (0, _classnames.default)('tooltip-trigger', 'js-tooltip-trigger', 'qa-latest-post-time'),
        dateTime: publishedAt === null || publishedAt === void 0 ? void 0 : publishedAt.split('T')[0]
      }, _common.common.relativeDate(publishTime)), (0, _preact.h)("div", {
        className: (0, _classnames.default)('tooltip__content', 'tooltip__content--publish-date', 'js-tooltip-content')
      }, (0, _dateFormatDestination.default)(publishTime))))), _common.common.isModuleActive('lastEditForArticle') && isEditedAtLeast24hAfterPublish && (0, _preact.h)("li", null, (0, _preact.h)("span", {
        "data-view": "Tooltip",
        className: "tooltip"
      }, (0, _preact.h)("span", {
        className: (0, _classnames.default)('tooltip-trigger', 'js-tooltip-trigger', 'qa-last-edited-time')
      }, (0, _preact.h)(_phrase.default, {
        m: "Forum",
        p: "topic.meta.last_edited",
        count: {
          time: _common.common.relativeDate(lastEditedTime)
        }
      })), (0, _preact.h)("div", {
        className: (0, _classnames.default)('tooltip__content', 'tooltip__content--publish-date', 'js-tooltip-content')
      }, (0, _dateFormat.default)(lastEditedTime)))), (0, _preact.h)("li", null, (0, _preact.h)("a", {
        href: "#comments",
        className: "qa-link-to-replies"
      }, (0, _preact.h)(_phrase.default, {
        m: "Forum",
        p: "topic.meta.reply",
        count: {
          n: totalReplyCount.toString()
        }
      }))), (0, _preact.h)("li", {
        className: "is-hidden-S qa-count-views"
      }, (0, _preact.h)(_phrase.default, {
        p: "topic.meta.views",
        count: {
          n: views.toString()
        }
      })), (0, _preact.h)("li", {
        className: "list-item_on-demand-translations"
      }, (0, _preact.h)(_OnDemandTranslations.OnDemandTranslationButton, {
        isTranslateAll: true
      }))));
    }
  }]);
  return TopicHeaderMetaInfo;
}(_preact.Component);

var ProductAreaLabel = function ProductAreaLabel(_ref2) {
  var name = _ref2.name;
  return (0, _preact.h)("span", {
    className: "text--dot-underline product-area-item",
    "data-qa": "product-area-item"
  }, name);
};

exports.ProductAreaLabel = ProductAreaLabel;
var _default = TopicHeaderMetaInfo;
exports.default = _default;